import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { LoadingWrapper } from 'barnyard/components';
import { localStorageHelper } from 'barnyard/utils';
import { Row, Col } from 'barnyard/layouts';
import { BarnyardIcon } from 'barnyard/icons';
import UserInfo from '../forms/UserInfo';
import { VENDOR_FORM_URL, LOCAL_STORAGE_PROFILE_FORM } from '../constants';

const classNamePrefix = 'Signup--FormPage';

class UserProfileView extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'handleSubmit');

    this.state = {
      profile: localStorageHelper.retrieveJson(LOCAL_STORAGE_PROFILE_FORM)
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { profileFetches: prevProfileFetches } = prevProps;
    const {
      profileFetches,
      profileFetchAction,
      profile,
      router,
      location
    } = this.props;

    if (!profileFetches.isError && prevProfileFetches.isCreating === true && profileFetches.isCreating === false) {
      if (_.isEmpty(profile)) {
        // If the profile is empty, that currently means that we were logged via the create request
        // let's fetch the profile
        profileFetchAction();
      } else {
        // Move to the vendor signup page because we have created the profile
        router.push({
          pathname: VENDOR_FORM_URL,
          search: location.search
        });
      }
    }
  }

  handleSubmit(values) {
    this.props.profileCreateAction(values);
  }

  render() {
    const {
      profileFetches
    } = this.props;
    const { profile } = this.state;

    return (
      <LoadingWrapper loading={profileFetches.isLoading}>
        <Row align='middle' justify='center' className={classNamePrefix}>
          <Col className={`${classNamePrefix}__title`} span={12}>
            <h2>Let&apos;s create your account.</h2>
            <h4>Signing up for Vetcove is fast and free - be up and running in under a minute.</h4>
          </Col>
          <Col span={12} className={`${classNamePrefix}__perks`}>
            <Row gutter='sm'>
              <Col span={4}>
                <p className={`${classNamePrefix}__perks__name`}>
                  <BarnyardIcon icon={['fa', 'check']} className={`${classNamePrefix}__perks__icon`} />
                  {' '}Quick and Easy
                </p>
                <p className='u-paddingLeft20'>Sign up and get started in minutes</p>
              </Col>
              <Col span={4}>
                <p className={`${classNamePrefix}__perks__name`}>
                  <BarnyardIcon icon={['fa', 'check']} className={`${classNamePrefix}__perks__icon`} />
                  {' '}No Setup Fees
                </p>
                <p className='u-paddingLeft20'>Only pay a 9.75% commission on anything you sell</p>
              </Col>
              <Col span={4}>
                <p className={`${classNamePrefix}__perks__name`}>
                  <BarnyardIcon icon={['fa', 'check']} className={`${classNamePrefix}__perks__icon`} />
                  {' '}Safe and Secure
                </p>
                <p className='u-paddingLeft20'>We secure all sensitive data using SSL & 256-bit encryption.</p>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <UserInfo
              onChange={values => localStorageHelper.saveJson(LOCAL_STORAGE_PROFILE_FORM, _.omit(values, 'password'))}
              initialValues={profile}
              disabled={profileFetches.isLoading}
              onSubmit={this.handleSubmit}
            />
          </Col>
        </Row>
      </LoadingWrapper>
    );
  }
}

UserProfileView.propTypes = {
  profileCreateAction: PropTypes.func.isRequired,
  profileFetchAction: PropTypes.func.isRequired,
  profileFetches: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default UserProfileView;
